import { MediumImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={MediumImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
